{
  "finish_setup_card": {
    "title": "Finish B2B setup",
    "badge": "Recommended first",
    "description": "Complete the remaining setup steps to activate SparkLayer on your store. You'll configure your B2B pricing, customer groups and ordering rules so you are ready to take orders.",
    "footer": "You'll finish in your Shopify Admin (about 10 minutes). Then we'll guide you through your customers' first orders.",
    "action": "Continue in Shopify"
  },
  "explore_card": {
    "title": "Explore what you can do",
    "description": "A quick feature overview of everything SparkLayer offers: pricing, quoting, ordering and more.",
    "action": "See features"
  },
  "onboarding_card": {
    "title": "Talk to onboarding",
    "description": "Book a call or chat with our team to get set up faster and get your questions answered.",
    "action": "Book onboarding call"
  },
  "what_is_card": {
    "title": "See how SparkLayer works",
    "description": "A short tour of what SparkLayer can do for your store.",
    "video_title": "See how SparkLayer works",
    "demo": {
      "title": "See how it looks on your website",
      "description": "See exactly how SparkLayer's B2B experience looks on your storefront. It's fully interactive, with nothing to install.",
      "action": "Launch live demo"
    }
  },
  "sales_performance_card": {
    "empty_state": {
      "title": "Your B2B store is ready for orders",
      "subtitle": "Orders will show up here once your customers start buying",
      "checkout_guide_action": "View checkout guide",
      "contact_support_action": "Contact support"
    },
    "date_options": {
      "last_7_days": "Last 7 days",
      "last_30_days": "Last 30 days",
      "last_90_days": "Last 90 days",
      "custom": "Custom"
    },
    "custom_range": {
      "start_label": "Start date",
      "end_label": "End date",
      "end_before_start_error": "End date must be on or after the start date"
    },
    "purchase_types": {
      "all": "All activity types",
      "order": "Orders",
      "quote": "Quotes",
      "awaiting_approval": "Awaiting approval",
      "awaiting_merchant": "Awaiting merchant",
      "archived": "Archived",
      "platform_archived": "Platform archived"
    },
    "stats_cards": {
      "orders": "Orders",
      "total_sales": "Total sales",
      "avg_order_val": "Average order value"
    },
    "chart": {
      "tooltip_title": "Sales Performance"
    }
  },
  "launched_next_steps_cards": {
    "ready_to_go": {
      "header": "You're ready to go with SparkLayer",
      "description": "Manage your B2B pricing, customers and shipping any time. Everything you need to run your store is just a click away.",
      "price_lists": {
        "title": "Price lists",
        "description": "Create automatic or CSV pricing for your B2B customers"
      },
      "customer_groups": {
        "title": "Customer groups",
        "description": "Assign pricing, payment methods and order rules"
      }
    },
    "get_more": {
      "header": "Get more from SparkLayer",
      "description": "SparkLayer goes well beyond price lists and customer groups. Speak to our team to discover powerful features like:",
      "topics": {
        "sales_agents": "Sales agents",
        "quote_orders": "Quote orders",
        "invoicing": "Invoicing",
        "discounts_promotions": "Discounts & promotions"
      },
      "action": "Book a meeting"
    }
  },
  "data_sync_cards": {
    "header": "Data sync health",
    "sync_status": "{count, plural, =0 {No sync issues} other {# sync {count, plural, =1 {issue} other {issues}}}}",
    "details": "Details",
    "load_error": "Unable to load sync status",
    "in_progress": "Data sync in progress",
    "product_sync": {
      "title": "Product sync",
      "view_action": "View product sync"
    },
    "customer_sync": {
      "title": "Customer sync",
      "view_action": "View customer sync"
    }
  },
  "billing_trial_badge": {
    "days_left": "{count} {count, plural, =1 {day} other {days}} left of free trial"
  },
  "additional_help_card": {
    "header": "Additional help",
    "book_onboarding": {
      "title": "Book onboarding call",
      "subtitle": "Speak with our expert team"
    },
    "help_center": {
      "title": "Help Center",
      "subtitle": "Browse setup guides"
    },
    "chat": {
      "title": "Chat with us",
      "subtitle": "Get quick support"
    }
  }
}
